export default __webpack_public_path__ + "static/media/0a.10f8dc66.jpg";